"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SvgSchemaViewerUnknown = void 0;
var React = require("react");
function SvgSchemaViewerUnknown(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 17 }, props),
        React.createElement("style", null, ".SchemaViewer_Unknown_svg__st0{fill:#666}"),
        React.createElement("path", { id: "SchemaViewer_Unknown_svg__Dot_1_", className: "SchemaViewer_Unknown_svg__st0", d: "M10.86 14v-1.14H12V14h-1.14z" }),
        React.createElement("path", { id: "SchemaViewer_Unknown_svg__Mark_1_", className: "SchemaViewer_Unknown_svg__st0", d: "M10.86 11c-.03-.305 0-.719 0-1.053 0-.66.1-1.135 1.419-2.032 1.066-.76 1.713-1.17 1.713-2.19 0-.978-.78-1.7-2.07-1.7-1.23 0-2.196.596-2.811 1.384l-.823-.668c.84-1.035 1.92-1.743 3.645-1.743 2.04 0 3.082 1.19 3.082 2.735 0 1.399-.553 1.948-1.687 2.76C12.069 9.383 12 9.426 12 11h-1.14z" })));
}
exports.SvgSchemaViewerUnknown = SvgSchemaViewerUnknown;
//# sourceMappingURL=SchemaViewerUnknown.js.map